const messages = {
  title: "Karbantartás!",
  description:
    'Jelenleg szükséges karbantartási munkálatok zajlanak a szervereken.<br/><br/>Ezért a <b>BRIDGESTONE <span class="text-danger">PLUS</span></b> jelenleg nem érhető el.<br/><br/>Kérjük türelmét, és köszönjük megértését.<br/><br/> Az Ön Bridgestone csapata',
}
export default {
  messages
}
